import React, { PureComponent } from 'react';
import { LoadingSpinner } from '~/components/loading-spinner';
import { getFeatures } from './features.api';
import { isFeatureEnabled } from './utils';

export const FeaturesContext = React.createContext(null);

export const withFeatures = (Component) =>
  class ComponentWithFeatures extends PureComponent {
    state = {
      isApiCallFinished: false,
      features: [],
    };

    async componentDidMount() {
      const features = await getFeatures();
      this.setState({
        isApiCallFinished: true,
        features,
      });
    }

    render() {
      const { isApiCallFinished, features } = this.state;

      const isBrandPromiseActive = isFeatureEnabled(features, 'jl_brand_promise');

      if (isApiCallFinished)
        return (
          <FeaturesContext.Provider
            value={{ isBrandPromiseActive, isBPLayoutActive: true, features }}
          >
            <Component {...this.props} />
          </FeaturesContext.Provider>
        );

      return <LoadingSpinner centered />;
    }
  };
